import React from "react";

import { Alert } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

interface MaxPassengersAlertProps {
  className?: string;
}
export const MaxPassengersAlert: React.FC<MaxPassengersAlertProps> = props => {
  const { translator } = useAppContext();
  return (
    <Alert severity="notice" className={props.className} as="div" hasRoleAlert>
      <Alert.Description>
        {translator.t("!search.passengers.error.title")}
      </Alert.Description>
    </Alert>
  );
};
